import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './ProviderEditScreen';
import ProviderEdit from './ProviderEditScreen';
import { StoreState } from 'src/store/reducers';
import {
    getProvider,
    getProviders,
    deleteFileProvider,
    getFiles,
    createFilesProvider,
    getSupervisorProviders,
} from 'src/store/actions/provider-actions';
import { QueryParams } from 'src/types/grid';
import { getServiceTypes } from 'src/store/actions/service-type-actions';
import { getServiceLocations } from 'src/store/actions/service-location-actions';
import { selectTitleProviders } from 'src/store/selectors/providers-selectors';
import { toast } from 'react-toastify';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        provider: state.providers.current,
        serviceTypes: state.serviceTypes.data,
        providersuper: state.providers.supervisorProviders,
        providers: selectTitleProviders(state),
        serviceLocations: state.serviceLocations.data,
        inProgress: state.providers.inProgress,
        files: state.providers.currentFiles,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getProvider(id)),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
        getServiceLocations: (params: QueryParams) => dispatch(getServiceLocations(params)),
        getFiles: (id) => dispatch(getFiles(id)),
        getProvidersSupervisor: (params: QueryParams) => dispatch(getSupervisorProviders(params)),
        getProviders: (params: QueryParams) => dispatch(getProviders(params)),
        // addFiles: async (id, files) => await asyncCreateFilesProvider(id, files, dispatch),
        addFiles: (id, requestType: string, files: any) =>
            dispatch(
                createFilesProvider(
                    id,
                    requestType,
                    files,
                    () => toast.success('File added successfully'),
                    (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                ),
            ),
        removeFile: (id) => dispatch(deleteFileProvider(id)),
    };
}

const ProviderEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ProviderEdit);

export default ProviderEditScreen;
